// NOTE: This file is not being used. We're using a custom event system instead.
// Keeping this file for reference in case we want to switch to Action Cable in the future.

import consumer from "./consumer"

// This file is not needed for our implementation since we're subscribing directly in the React component
// But we'll create it for completeness

/*
consumer.subscriptions.create("CoinChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
  }
});
*/

// Create a subscription for the coin channel
// This will be used to receive real-time coin updates
const createCoinSubscription = (userId) => {
  console.log('Creating coin subscription for userId:', userId);

  // Don't create a subscription if userId is missing
  if (!userId) {
    console.warn('Cannot create coin subscription: userId is missing');
    return { unsubscribe: () => {} }; // Return a dummy object with unsubscribe method
  }

  // Convert userId to a number if it's not already
  const parsedUserId = typeof userId === 'number' ? userId : parseInt(userId, 10);
  console.log('Parsed userId:', parsedUserId);

  try {
    const subscription = consumer.subscriptions.create(
      {
        channel: "CoinChannel",
        user_id: parsedUserId
      },
      {
        connected() {
          // Called when the subscription is ready for use on the server
          console.log("Connected to CoinChannel for user", parsedUserId);
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
          console.log("Disconnected from CoinChannel");
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          console.log("Received coin update:", data);
          if (data && data.coins !== undefined) {
            // Ensure we're working with numbers
            const coins = typeof data.coins === 'number' ? data.coins : parseInt(data.coins, 10);
            const user_id = typeof data.user_id === 'number' ? data.user_id : parseInt(data.user_id, 10);

            console.log('Dispatching coin-update event with:', { userId: user_id, coins });

            // Dispatch a custom event that the CoinDisplay component can listen for
            document.dispatchEvent(new CustomEvent('coin-update', {
              detail: {
                userId: user_id,
                coins: coins
              }
            }));
          }
        }
      }
    );

    console.log('Subscription created successfully');
    return subscription;
  } catch (error) {
    console.error('Error creating subscription:', error);
    return { unsubscribe: () => {} }; // Return a dummy object with unsubscribe method
  }
};

export default createCoinSubscription;